import {CHANGE_ADVANCE_DISBURSEMENTS_TAB_STORE_SETTINGS, CLOSE_AD_MODAL, OPEN_AD_MODAL} from "./index";

//action that changes the ad tab settings
export function changeAdvanceDisbursementsTabStoreSettings(payload) {
    return {
        type: CHANGE_ADVANCE_DISBURSEMENTS_TAB_STORE_SETTINGS,
        payload: payload
    }
}

//action that open the advance disbursements tab
export function openAdModal() {
    return {
        type: OPEN_AD_MODAL
    }
}

//action that closes the ad modal
export function closeAdModal() {
    return {
        type: CLOSE_AD_MODAL
    }
}